import React from "react";
import { PharmacyLoginDiv } from "./style";
import llogo from "../../../../assets/images/llogo.png";
import { Link } from "react-router-dom";

function PharmacyLogin() {
  return (
    <PharmacyLoginDiv>
      <div className=" row inner-container">
        <div className="col-md-6 left-div">
          <img src={llogo} alt="" />
          <h3>
            Welcome to<br />
            <span>Medi</span>
            first
          </h3>
          <p>You are seeing this because you registered as a Pharmacy with Medifirst.</p>
          <p>Kindly check your email for your 8 digit OTP</p>
        </div>

        <div className="col-md-6 right-div">
          <form>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder=" Enter Email Address"
              />
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>

            <div className="form-group">
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                placeholder="Password"
              />
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
              />
              <label className="form-check-label" for="exampleCheck1">
                Remember Me{" "}
              </label>
            </div>

            <button type="submit" className="btn">
              Login
            </button>
          </form>
          <div className="last-part">
            <h4>Have Account?</h4>
            <Link>
              <h4>
                <span>LOGIN</span>
              </h4>
            </Link>
          </div>
        </div>
      </div>
    </PharmacyLoginDiv>
  );
}

export default PharmacyLogin;